
import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component({
      name: 'Accordion'//
    })
export default class Accordion extends Vue {
  // #region Props

      @Prop({ default: false }) open!: boolean;
        @Prop() name!: string;
        @Prop({ default: '' }) title!: string;
        @Prop({ default: false }) overflow!: boolean;

        // #endregion

        // #region Computed

        get hasTitle () {
          return !!this.$slots.title
        }

        get hasBody () {
          return !!this.$slots.body
        }

        get accordionHeight () {
          if (this.open && document.getElementById(this.name)) {
            return document.getElementById(this.name)!.clientHeight + 'px'
          }

          return '0px'
        }

  // #endregion
}
